import { render, staticRenderFns } from "./reportInfo.vue?vue&type=template&id=5def36bc&scoped=true"
import script from "./reportInfo.vue?vue&type=script&lang=js"
export * from "./reportInfo.vue?vue&type=script&lang=js"
import style0 from "./reportInfo.vue?vue&type=style&index=0&id=5def36bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5def36bc",
  null
  
)

export default component.exports